import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../firebase";

const MAX_SIZE = 15 * 1024 * 1024;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

const safeName = (name) => name.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 120);

export const uploadBudgetAttachment = ({
  file,
  orgId,
  budgetId,
  entryId,
  onProgress,
}) => {
  if (!ALLOWED_TYPES.includes(file.type)) throw new Error("Unsupported attachment type");
  if (file.size > MAX_SIZE) throw new Error("Attachment is limited to 15 MB");
  const fileName = `${Date.now()}-${safeName(file.name)}`;
  const storagePath = `budgets/${orgId}/${budgetId}/entries/${entryId}/${fileName}`;
  const uploadTask = uploadBytesResumable(ref(storage, storagePath), file, {
    contentType: file.type,
  });

  const promise = new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => onProgress?.(Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)),
      reject,
      async () => {
        resolve({
          storagePath,
          downloadUrl: await getDownloadURL(uploadTask.snapshot.ref),
          fileName: file.name,
          mimeType: file.type,
          size: file.size,
        });
      },
    );
  });
  promise.cancel = () => uploadTask.cancel();
  return promise;
};

export const deleteBudgetAttachment = (storagePath) =>
  storagePath ? deleteObject(ref(storage, storagePath)).catch(() => null) : Promise.resolve();
